(() => {
  document.querySelectorAll('.pub-mobile-menu').forEach(menu => {
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.removeAttribute('open')));
    menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); } });
    document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
  });
  const packageSelect = document.getElementById('OQPackage');
  const requestedPackage = new URLSearchParams(location.search).get('package');
  if (packageSelect && Array.from(packageSelect.options).some(option => option.value === requestedPackage)) packageSelect.value = requestedPackage;
  document.querySelector('.oq-success')?.focus();
})();
